import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';
import { AuthGuard } from 'src/auth/guard';

import StockPage from 'src/pages/stock/stock/stock';
import StockImportPage from 'src/pages/stock/stock-import/stock-import';
import StockExportPage from 'src/pages/stock/stock-export/stock-export';
import StockReportPage from 'src/pages/stock/stock-report/stock-report';

export const stockRoutes = [
  {
    path: 'stock',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <StockPage />, index: true },
      { element: <StockPage />, path: 'summary' },
      { element: <StockImportPage />, path: 'import' },
      { element: <StockExportPage />, path: 'export' },
      { element: <StockReportPage />, path: 'report' },
    ],
  },
];
